import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';
import useTranslation from '../../../hooks/useTranslation';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const AboutUs = (props) => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>{t('about')}</h3>
              <p className={classes.aboutUsText}>
                {t('aboutUsText')}
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}about`}
              >
                {t('exploreAboutUs')}
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}about/meet-the-team`} rel="noopener noreferrer">{t('team')}</a></li>
                    <li><a href={`${SITE_LINK}about/3ie-members`} rel="noopener noreferrer">{t('members')}</a></li>
                    <li><a href={`${SITE_LINK}about/governance`} rel="noopener noreferrer">{t('governance')}</a></li>
                    <li><a href={`${SITE_LINK}about/policies-reports`} rel="noopener noreferrer">{t('policies')}</a></li>
                  </ul>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.aboutUsRightCol}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}about/3ie-supporters`} rel="noopener noreferrer">{t('supporters')}</a></li>
                    <li><a href={`${SITE_LINK}about/3ie-at-a-glance`} rel="noopener noreferrer">{t('atAGlance')}</a></li>
                    <li><a href={`${SITE_LINK}about/3ie-partners`} rel="noopener noreferrer">{t('partners')}</a></li>
                    <li><a href={`${SITE_LINK}about/contact-us`} rel="noopener noreferrer">{t('contactUs')}</a></li>
                  </ul>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

AboutUs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AboutUs);
